"use client";
import { useEffect, useRef } from "react";
import Lenis from "lenis";

let instance = null; // globalny dostęp do instancji Lenis

export default function SmoothScroll() {
  const lenisRef = useRef(null);

  useEffect(() => {
    // Inicjalizacja Lenis
    lenisRef.current = new Lenis({
      duration: 1.2, // czas przewijania
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing
      smooth: true,
    });

    instance = lenisRef.current;

    // Funkcja animacji klatek
    function raf(time) {
      lenisRef.current.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }, []);

  return null; // komponent nic nie renderuje
}

// globalna funkcja do smooth scroll
export function scrollToElement(selector, offset = 0) {
  if (!instance) return;
  const el = document.querySelector(selector);
  if (el) {
    instance.scrollTo(el, { offset, duration: 1.6 });
  }
}
